import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { XIcon } from 'lucide-react';
export function WhyFailed() {
  const reasons = [{
    title: 'Cardio intenso eleva cortisol',
    description: 'El cardio intenso eleva tu cortisol, bloqueando la quema de grasa abdominal de inmediato.'
  }, {
    title: "Productos 'Light' con edulcorantes",
    description: "Los productos 'Light' están llenos de edulcorantes que destruyen tu microbiota y te hinchan en minutos."
  }, {
    title: 'Saltarte el desayuno dispara insulina',
    description: 'Saltarte el desayuno dispara tu insulina y te garantiza antojos incontrolables por la tarde.'
  }, {
    title: 'Dietas estándar ignoran cambio hormonal',
    description: 'Las dietas estándar no consideran tu cambio hormonal y tratan tu cuerpo como el de un hombre de 20 años.'
  }];
  return <SectionWrapper className="bg-white" data-id="element-190">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-charcoal" data-id="element-191">
        Por qué nada de lo que has intentado funciona
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-192">
        {reasons.map((reason, index) => <div key={index} className="bg-cream p-6 rounded-xl flex items-start space-x-4" data-id="element-193">
            <div className="flex-shrink-0 bg-red-100 p-2 rounded-full mt-1" data-id="element-194">
              <XIcon className="w-6 h-6 text-red-500" data-id="element-195" />
            </div>
            <div data-id="element-196">
              <h3 className="font-bold text-lg text-charcoal mb-2 font-sans" data-id="element-197">
                {reason.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-198">
                {reason.description}
              </p>
            </div>
          </div>)}
      </div>
    </SectionWrapper>;
}